import createI18n from '@sparebankenvest/i18n';
import i18nTemplate from './i18nTemplates';

let i18n;

export default (...args) => {
  if (!i18n) {
    i18n = createI18n(i18nTemplate);
  }
  return i18n(...args);
};
